// Роли пользователя — единственное место во фронте, где они перечислены.
//
// Зеркало бэкенда (rentalman-api, app/models/user.rb):
//   enum :role, [ :admin, :manager, :user, :superadmin, :guest, :partner, :agent ]
// Порядок важен: в БД лежит индекс массива, а не строка.
export const ALL_ROLES = [
  "admin",
  "manager",
  "user",
  "superadmin",
  "guest",
  "partner",
  "agent",
];

// Сотрудники компании. Зеркало Api::V1::TasksController::STAFF_ROLES —
// того самого списка, по которому ensure_staff! отдаёт 403.
//
// Это ALLOWLIST, и менять форму на «не guest и не partner» нельзя: именно
// отрицание дало инцидент 12.08.2026 — роль agent, добавленную позже
// остальных, забыли внести в перечисления, и она проходила через ~274
// проверки по всему фронту. Новая не-staff роль на бэкенде при allowlist
// не получит доступ молча.
export const STAFF_ROLES = ["superadmin", "admin", "manager", "user"];

// Внешние по отношению к компании роли, каждая со своей причиной отказа:
//   guest   — наблюдатель: видит всё, кроме персональных данных, не меняет ничего
//   agent   — внешний агент (стойка отеля): оформляет бронь, видит свои брони;
//             точные права сверх этого — в user.agent_setting, а не в роли
//   partner — инвестор: видит только свои машины и пару настроек видимости
export const NON_STAFF_ROLES = ["guest", "agent", "partner"];

// Кто смотрит на компанию изнутри: сотрудники плюс guest. Guest не может
// ничего менять, но видит всё, кроме персональных данных, — поэтому в
// НАВИГАЦИИ и прочих чисто смотровых местах он идёт вместе с сотрудниками,
// а agent и partner (внешние контрагенты со своей узкой областью) — нет.
//
// Ровно это и означала форма «не partner и не agent», которой размечено
// главное меню: в ней отсутствие guest — не забывчивость, а смысл.
export const INTERNAL_ROLES = [...STAFF_ROLES, "guest"];

// Ярус управления компанией: настройки, платёжные реквизиты, шаблоны
// документов, сверка счетов. Роль user (рядовой сотрудник) сюда не входит —
// этим и отличается от STAFF_ROLES.
export const MANAGER_PLUS_ROLES = ["superadmin", "admin", "manager"];

// Владелец компании и админ — без manager'а. Отдельный ярус, потому что
// сочетание «admin или superadmin» было выписано руками 23 раза в скриптах
// и ещё в шаблонных гейтах (`v-if="user_role == 'superadmin' || …"`), а одно
// из написаний (AnnouncementBar) жило локальным computed с именем isAdmin —
// тем же, что у глобального геттера «строго admin», но с другим множеством.
// Шаблонные вхождения нашлись только после того, как инвариант-тест перестал
// ограничиваться условиями if.
export const ADMIN_PLUS_ROLES = ["superadmin", "admin"];

// Владелец компании — ровно одна роль. Нужна там, где ярус ADMIN_PLUS слишком
// широк: например, запрос оценки приложения в сторе задаём только владельцу.
export const OWNER_ROLE = "superadmin";
